import React from 'react';
import { useField } from 'formik';

export default function TextField({ name, className, ...props }) {
  const [field, meta] = useField(name);

  return (
    <div className={`col ${className}`}>
      <input
        type="text"
        className={`text-input-field ${className}`}
        data-lpignore="true"
        {...field}
        {...props}
      />
      {meta.touched && meta.error ? (
        <div className="error">{meta.error}</div>
      ) : null}
    </div>
  );
}
